import getStatusTextAndColor from '@components/ReportList/utils/getStatusTextAndColor';
import { ReportSummary } from '@components/ReportList/reportList.types';
import { ReportResponseDto } from '@api/WhisApi/generated';
import { i18n } from 'i18next';

export function mapReportToSummary(
  report: ReportResponseDto,
  i18n: i18n,
): ReportSummary {
  const etiologyType = report.etiologyType?.name[i18n.language];
  const etiologicalAgent = report.etiologicalAgent?.name[i18n.language];
  const status = getStatusTextAndColor(report.status);
  const countryCode = report.country?.code || '';
  const countryName = report.country?.name?.[i18n.language] || '';
  const individualsNumberFilled =
    typeof report.numberOfDeaths === 'number' ||
    typeof report.numberOfSicks === 'number';
  const numberOfDeaths = Number(report.numberOfDeaths) || 0;
  const numberOfSicks = Number(report.numberOfSicks) || 0;

  return {
    id: report.id,
    code: report.code,
    specie: report.specie || '',
    location: countryName || countryCode,
    etiologicalAgent: etiologyType || '',
    etiologyType: etiologicalAgent || '',
    individualsAffected: individualsNumberFilled
      ? numberOfDeaths + numberOfSicks
      : undefined,
    detectionDate: report.detectionDate
      ? new Date(report.detectionDate).toLocaleDateString(i18n.language)
      : '',
    countryCode,
    countryName,
    status: status,
    latitude: report.latitude,
    longitude: report.longitude,
  };
}
